  if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
      if (typeof start !== 'number') {
        start = 0;
      }

      if (start + search.length > this.length) {
        return false;
      } else {
        return this.indexOf(search, start) !== -1;
      }
    };
  }

$(document).ready(function() {
  $('html').removeClass('no-js').addClass('js');

  // Homepage
  setupSinglePortrait = function(img){
    return '<div class="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3"><a class="portrait" href="' + img.data('url') + '" style="background-image: url(' + img.data('src') + ')"><span>' + img.data('title') + '</span></a></div>'
  }

  setupDoublePortrait = function(img, nextImg){
    a = '<div class="col-xs-12 col-sm-6"><a class="portrait" href="' + img.data('url') + '" style="background-image: url(' + img.data('src') + ')"><span>' + img.data('title') + '</span></a></div>'
    b = '<div class="col-xs-12 col-sm-6"><a class="portrait" href="' + nextImg.data('url') + '" style="background-image: url(' + nextImg.data('src') + ')"><span>' + nextImg.data('title') + '</span></a></div>'
    return a + b
  }

  setupSingleLandscape = function(img){
    return '<div class="col-xs-12"><a class="landscape" href="' + img.data('url') + '" style="background-image: url(' + img.data('src') + ')"><span>' + img.data('title') + '</span></a></div>'
  }

  container = $('.homepage-grid')
  homeImgs = container.find('img')

  homeImgs.each(function(){
    img = $(this)

    if(img.hasClass('skip')){
      // Skip
    } else {

      nextImg = img.next('img')

      if(img.data('type') == "landscape"){
        a = setupSingleLandscape(img)
      } else {
        if(img.data('type') == nextImg.data('type')){
          a = setupDoublePortrait(img, nextImg)
          nextImg.addClass('skip')
        } else {
          a = setupSinglePortrait(img)
        }
      }
      $(a).appendTo(container)
    }
    img.remove()
  })

  // Sidebar Setup
  $('.bold').click(function(){
    $(this).siblings('.bold').next('.menu').removeClass('in');
  });

  
  $('[data-toggle="collapse"]').click(function(){
     //$(this).siblings('span.active:not(.bold)').click()
    $(this).toggleClass('active');
    var collapse_parent = $(this).parent();
    if (collapse_parent.hasClass('colors-list')){
      collapse_parent.toggleClass('active_color');
      collapse_parent.find('.menu').toggleClass('in');
    }
  });

  $('.btn-menu-back').click(function(){
    span = $(this).parents('.in:first').prev('span');
    span.click();
  });

  $('.sidebar-list').on('click', 'span.active', function(){
    if($(window).width() > 767) {
      $(this).siblings('span.active:not(.bold)').click()
    }
  })

  // SET GENDER
  if(window.location.pathname.includes('women') || window.location.pathname.includes('womens')){
    Cookies.set('gender', 'women');
  } else if(window.location.pathname.includes('men') || window.location.pathname.includes('mens')){
    Cookies.set('gender', 'men');
  }

  // SET CONTINUE SHOPPING URL
  if(Cookies.get('gender') == 'women'){
    $('.continue-shopping').attr('href', '/collections/women')
    cookieGender = 'women'
  } else {
    $('.continue-shopping').attr('href', '/collections/men')
    cookieGender = 'men'
  }

  gender = 'men';
  categories = $('#categories-men');
  designers = $('#designers-men')
  if(window.location.pathname.includes('women')){
    gender = 'women';
  } else if(!window.location.pathname.includes('women') && !window.location.pathname.includes('men') && cookieGender == 'women') {
    gender = 'women';
  }
  if(gender == 'women'){
    categories = $('#categories-women');
    designers = $('#designers-women');
  }

  // ACTIVE HEADER NAV
  if(window.location.pathname != "/" && !window.location.pathname.includes('pages') && !window.location.pathname.includes('account') && !window.location.pathname.includes('cart') && !window.location.pathname.includes('search')){
    $('.navbar-nav-' + gender).addClass('current')
  }

  // ACTIVATE SIDEBAR MENUES
  $('.sidebar').addClass(gender);

  categories.find('.active').each(function(){
    if(!$(this).parents('.designer-list').length){
      $(this).parents('.collapse').each(function(){
        $(this).addClass('in');
      });
      $(this).next('.collapse').addClass('in');
      $(this).parents('.categories-list').prev('span').addClass('active not-bold')
    }
  });

//   $('#designers-men-bottom .active, #designers-women-bottom .active').each(function(){
//     $(this).parents('.collapse').each(function(){
//       $(this).addClass('in');
//       $(this).prev('span').addClass('active');
//     });
//   });

//   $('.colors-list .active').each(function(){
//     $(this).parents('.collapse').each(function(){
//       $(this).addClass('in');
//       $(this).prev('span').addClass('active');
//     });
//   });  
  
  // SET BRAND
  if($('body').hasClass('template-product')){
    currentDesigner = $('.designer a');
    if(currentDesigner.html() == "HL ARCHIVE"){
      designerHref = "https://hlorenzo-2.myshopify.com/collections/h-lorenzo-archive";
    } else {
      designerHref = designers.find("[data-title='" + currentDesigner.html() + "']").attr('href');
    }
    currentDesigner.attr('href', designerHref);
  }

  // MOBILE MENU TOGGLE
  $('.menu-toggle').click(function(){
    attrFor = $(this).attr('for');
    $('.' + attrFor).toggleClass('open')
    $('#main-container-overlay').toggleClass('open')
  })

  $('#main-container-overlay').click(function(){
    $('.menu.open').removeClass('open')
    $('#main-container-overlay').removeClass('open')
  })

  // SETUP COLOR TAG URLS
  colors = ['black', 'white', 'gray', 'brown', 'red', 'pink', 'orange', 'yellow', 'green', 'blue', 'purple', 'print', 'multicolor', 'metallic']
  path = $(window.location.pathname.split('+')).get(0)
  urlArray = $(path.split('/'))
  currentTag = urlArray.get(-1);

  addColorTag = true
//   if(currentTag.includes('new-arrivals')){
//     addColorTag = false
//   }
  if(['women', 'men'].some(x => x === currentTag.toLowerCase())){
    addColorTag = false
  }

  for (i = 0; i < colors.length; i++) {
    if(currentTag.includes(colors[i])){
      addColorTag = false
    }
  }

  if(addColorTag){
    $('.colors-list a').each(function(){
      colorUrlArray = $($(this).attr('href').split('/'));
      colorTag = colorUrlArray.get(-1)
      $(this).attr('href', path + '+' + colorTag)
    })
  }

  $('[data-update-qty-up]').click(function(){
    id = $(this).data('update-qty-up');
    val = parseInt($(id).val());
    $(id).val(val + 1);
  })

  $('[data-update-qty-down]').click(function(){
    id = $(this).data('update-qty-down');
    val = parseInt($(id).val());
    $(id).val(val - 1);
  })

  // SETUP STORE GUIDE LANDING
  if($('#store-guide-images').length){
    $('#store-guide-women-image').css('background-image', 'url(' + $('#store-guide-images').data('women') + ')');
    $('#store-guide-men-image').css('background-image', 'url(' + $('#store-guide-images').data('men') + ')');
    $('#store-guide-hlnr-image').css('background-image', 'url(' + $('#store-guide-images').data('hlnr') + ')');
    $('#store-guide-archive-image').css('background-image', 'url(' + $('#store-guide-images').data('archive') + ')');
  }

  if($('#store-women').length){
    $('#image-001').css('background-image', 'url(' + $('#store-guide-data').data('image-001') + ')');
    $('#image-002').attr('src', $('#store-guide-data').data('image-002'));
  }

  if($('#store-men').length){
    $('#image-001').attr('src', $('#store-guide-data').data('image-001'));
    $('#image-002').attr('src', $('#store-guide-data').data('image-002'));
  }

  if($('#store-hlnr').length){
    $('#video-001').attr('src', $('#store-guide-data').data('video-001'));
    $('#image-001').css('background-image', 'url(' + $('#store-guide-data').data('image-001') + ')');
    $('#image-002').attr('src', $('#store-guide-data').data('image-002'));
  }

  if($('#store-archive').length){
    $('#image-001').attr('src', $('#store-guide-data').data('image-001'));
    $('#image-002').css('background-image', 'url(' + $('#store-guide-data').data('image-002') + ')');
    $('#image-003').css('background-image', 'url(' + $('#store-guide-data').data('image-003') + ')');

  }

  if($('#store-guide-data').length){
    $('#image-sq-001').attr('src', $('#store-guide-data').data('image-sq-001'));
    $('#image-sq-002').attr('src', $('#store-guide-data').data('image-sq-002'));
    $('#image-sq-003').attr('src', $('#store-guide-data').data('image-sq-003'));
    $('#image-sq-004').attr('src', $('#store-guide-data').data('image-sq-004'));
    $('#image-sq-005').attr('src', $('#store-guide-data').data('image-sq-005'));
  }

  $('.sidebar').removeClass('loading')

  setSidebarPosition = function(){
    if($('.sidebar').height() < $('.sidebar-nav').height()){
      scrollable = $('.sidebar-nav').height() - $('.sidebar').height();
      if($(document).scrollTop() < scrollable){
        $('.sidebar-nav').css('margin-top', -$(document).scrollTop());
      } else {
        $('.sidebar-nav').css('margin-top', -scrollable);
      }
    } else {
      $('.sidebar-nav').css('margin-top', 0);
    }

    if($('#maincontainer').height() < $('.sidebar-nav').height()) {
      scrollPercent = $(window).scrollTop() / ($(document).height() - $(window).height());
      scrollable = $('.sidebar-nav').height() - $('.sidebar').height();
      margin = scrollable * scrollPercent;
      $('.sidebar-nav').css('margin-top', -margin);
    }
  }

  $(window).scroll(function() {
    setSidebarPosition()
  });

  $(window).on('load',function(){
    setSidebarPosition()
  });

  $(window).on('resize',function(){
    setSidebarPosition()
  });

  $('[data-toggle="collapse"]').on('click',function(){
    setSidebarPosition()
  });

  // Show Search 
  //changig show search to on hover. before it was on click
  $('.showSearch').on('mouseover', function(e){
    e.preventDefault();
    $('.desktop-search').show();
    $(this).hide();
    $('.desktop-search input[name="q"]').focus();
  })

  $('.show-mobile-search').on('click', function(e){
    e.preventDefault();
   
    if($('.mobile-search').is(":visible") == true)
    {
    	$('.mobile-search').hide();
    }
    else{
       $('.mobile-search').show();
       $('.mobile-search input[name="q"]').focus();
    }
    //if($('.mobile-search').show() == true){
    
  })

  $('#searchFormSubmit').on('mouseleave', function(e){
    e.preventDefault();
    $('.desktop-search, .mobile-search').hide();
    $('.showSearch').show();
  })

  // FOOTER SUBSCRIBE POPUP
  $('.subscribe-toggle').click(function(e){
    e.preventDefault()
    $('.navbar-form').toggleClass('open');
    $('input.email').focus();
  });
  

///  Collection Sidebar
  var width = $(window).width();
  if (width > 834){
    var popup_width = width - $('.sidebar').width();
    $('#designers-men-bottom').css('width', popup_width);
    $('#categories-men-bottom').css('width', popup_width);
    $('#designers-women-bottom').css('width', popup_width);
    $('#categories-women-bottom').css('width', popup_width);
    
//     $(".color_link").click(function(){
//       $(this).css("display", "none");
//       $(".color_items").css("display", "flex");
//     });
//     $(".color_title").click(function(){
//       $(".color_items").css("display", "none");
//       $(".color_link").css("display", "block");
//     });
    
    var men_submenu = $('#categories-men-bottom .menu_list .active').closest(".submenu_list");
    men_submenu.addClass("active_submenu");
    var active_title = men_submenu.attr("data-link");
    
    $("#categories-men-bottom .main_list li").each(function(){
      var list = $(this);
      if (active_title == list.attr("data-link")){
      	list.addClass("active_list");
      }
    });
    
    if($("#categories-men-bottom .active_submenu").length == 0){
      $("#categories-men-bottom .menu_list .submenu_list").first().addClass("active_submenu");
      $("#categories-men-bottom .main_list li").first().addClass("active_list");
    }
    
    var women_submenu = $('#categories-women-bottom .menu_list .active').closest(".submenu_list");
    women_submenu.addClass("active_submenu");
    var active_title = women_submenu.attr("data-link");
    
    $("#categories-women-bottom .main_list li").each(function(){
      var list = $(this);
      if (active_title == list.attr("data-link")){
      	list.addClass("active_list");
      }
    });
    
    if($("#categories-women-bottom .active_submenu").length == 0){
      $("#categories-women-bottom .menu_list .submenu_list").first().addClass("active_submenu");
      $("#categories-women-bottom .main_list li").first().addClass("active_list");
    }    
    
  }  

  $(window).on('resize', function(){
    var width = $(window).width();
    if (width > 834){
      var popup_width = width - $('.sidebar').width();
      $('#designers-men-bottom').css('width', popup_width);
      $('#categories-men-bottom').css('width', popup_width);
      $('#designers-women-bottom').css('width', popup_width);
      $('#categories-women-bottom').css('width', popup_width);
    }else{
      $('#designers-men-bottom').css('width', 'auto');
      $('#categories-men-bottom').css('width', 'auto');
      $('#designers-women-bottom').css('width', 'auto');
      $('#categories-women-bottom').css('width', 'auto');   
      $("#categories-men-bottom").removeClass("in");
      $("#categories-women-bottom").removeClass("in");       
    } 
    if ( width == 835){

      $(".sidebar-list>span").each(function(){
      	var active_list = $(this);
        if (active_list.hasClass('active')){
        	active_list.trigger('click');
        }
      });    
    }
  });

  $('.main_list li').click(function(){
  	var main_list = $(this);
    if (!(main_list.hasClass('active_list'))){
      $('.main_list li').removeClass('active_list');
      main_list.addClass('active_list');
      var list_link = main_list.attr('data-link');
      $('.submenu_list').removeClass('active_submenu');
      $('.' + list_link).addClass('active_submenu');
    }
  });
  
  $('.description-down').click(function(){
    $('.product-form').addClass('expanded');
  });
  $('.description-up').click(function(){
    $('.product-form').removeClass('expanded');
  });
  $('.remove_nestednav').click(function(){
    var active_span = $(this).closest('.collapse').prev('span');
    active_span.click();
  });
  
  $(document).click(function(e){
    var container = $(".sidebar-list > .collapse.menu.in");
    if (!container.is(e.target) && container.has(e.target).length === 0){
      container.prev('span').click();
    }
  });
  

// Collection Grid Purchase   
  // Use event delegation for dynamically loaded elements
$('body').on('click', '.add_button', function(){
    var add_button = $(this);
    if (add_button.closest('.product_add').find('.product_variants input:checked').length > 0){
        var variant_id = add_button.closest('.product_add').find('.product_variants input:checked').attr('value');
        console.log(variant_id);
        data = {
            "id": variant_id,
            "quantity": 1
        }

        add_button.find('a').html('ADDING...');
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function (data) {
                add_button.find('a').html('ADDED');
                $.ajax({
                    type: 'GET',
                    dataType: 'json',
                    url: '/cart.json',
                    success: function(cart){
                        add_button.find('a').html
                        var cart_count = cart.item_count;
                        $(".header-bar__cart-count").html(cart_count);
                        setTimeout(function(){
                            add_button.find('a').html('ADD TO BAG');
                        }, 1000);
                    }
                });
            },
            error: function (request, error) {
                add_button.find('a').html('Failed...');
                setTimeout(function(){
                    add_button.find('a').html('ADD TO BAG');
                }, 1000);
            }
        });
    }
});

  
  
  
  
});

$(document).ready(function() {
    var linkElement = $(".s-750a3ffb-8f11-4130-a97c-31fcbd29a973 .shg-image-content-wrapper .shogun-image-link");
    if (linkElement.length > 0) {
      linkElement.attr("aria-label", "hlorenzo video");
    }
    
    console.log("linkElement=======", linkElement);
  });


